<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form
        :model="state.model"
        label-width="0"
        :scroll-to-error="true"
        :show-message="false"
        ref="formDom"
        size="large"
      >
        <el-descriptions
          :column="$store.state.width > 1440 ? 4 : 3"
          border
          class="desc-box"
        >
          <el-descriptions-item label="上级菜单" label-align="right">
            <el-form-item label="">
              <el-tree-select
                v-model="state.model.pid"
                :data="state.treeData"
                node-key="id"
                clearable
                accordion
                :props="{ label: 'name' }"
                :render-after-expand="false"
                :highlight-current="true"
                :default-expand-all="true"
                :check-strictly="true"
                placeholder="--上级菜单--"
                :disabled="props.id"
                @clear="delete state.model.SjId"
              >
                <template #default="{ data }">
                  <div style="display: flex; align-items: center">
                    {{ data.name }}
                  </div>
                </template>
                <template #footer>
                  <el-button size="small" @click="onLoadTree">刷新</el-button>
                </template>
              </el-tree-select>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item
            label="菜单名称"
            :label-class-name="state.model.name ? 'color-green' : 'color-red'"
            label-align="right"
          >
            <el-form-item
              label=""
              prop="name"
              :rules="[
                { required: true, message: '请填写名称', trigger: 'blur' },
              ]"
            >
              <el-input v-model="state.model.name"></el-input>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item label="菜单类型" label-align="right">
            <el-form-item label="">
              <el-radio-group v-model="state.model.type">
                <el-radio-button :label="1">菜单</el-radio-button>
                <el-radio-button :label="0">按钮</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item label="路径" label-align="right">
            <el-form-item label="">
              <el-input v-model="state.model.code"></el-input>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item label="图标" label-align="right">
            <el-form-item label="">
              <el-input v-model="state.model.icon"></el-input>
            </el-form-item>
          </el-descriptions-item>
          <template v-if="props.id">
            <el-descriptions-item
              label="创建时间"
              label-align="right"
              :span="66"
            >
              <el-form-item label="">
                <el-input v-model="state.model.create_time" disabled></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item
              label="修改时间"
              label-align="right"
              :span="66"
            >
              <el-form-item label="">
                <el-input v-model="state.model.update_time" disabled></el-input>
              </el-form-item>
            </el-descriptions-item>
          </template>
        </el-descriptions>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { menu_tree, menu_add, menu_edit, menu_detail } from "@/http/menu";
import { post_response } from "@/utils/qFormat";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        type: 0,
        code: "Home",
      },
    });
    onMounted(() => {
      onLoadTree();

      if (props.id) {
        menu_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;
            if (state.model.pid == 0) delete state.model.pid;
          }
        });
      }
    });

    const onLoadTree = () => {
      menu_tree(state.params).then((res) => {
        if (res.status == 200) {
          state.treeData = res.data.data.list;
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            menu_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            menu_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onLoadTree,
      onSubmit,
    };
  },
};
</script>
<style scoped lang="less"></style>
